import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  border: 1px solid #f1c788;
  border-radius: 8px;
  padding: 10px;
`;


const Well = ({ children, ...props }) => <Container { ...props }>
  {children}
</Container>

export default Well;



// WEBPACK FOOTER //
// ./src/components/Well/index.js